module.exports = __webpack_public_path__ + "img/3.15ed5320.png";